module.exports = __webpack_public_path__ + "static/img/confirm_delete.87fee7b2.svg";